<template>
    <div class="dynamicDiv">
        <div class="contentHeader">
            <div>
                <el-form :inline="true" ref="form" label-width="90px">
                    <el-row>
                        <el-col :span="3">
                            <el-button size="mini" @click="dialogEditDynamicResourceVisible=true">添加</el-button>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item size="mini" label="环境：">
                                <el-select v-model="env" filterable placeholder="请选择">
                                    <el-option v-for="item in envOptions" :key="item.value" :label="item.key"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item size="mini" label="租户id：">
                                <el-input v-model="tnId" placeholder="请输入租户id搜索"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item size="mini" label="资源类型：">
                                <el-select v-model="resourceType" filterable allow-create default-first-option clearable placeholder="请选择">
                                    <el-option v-for="item in resourceTypeOptions" :key="item.value" :label="item.key"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item size="mini" label="是否启用：">
                                <el-select v-model="status" filterable allow-create default-first-option clearable placeholder="请选择">
                                    <el-option v-for="item in statusOptions" :key="item.value" :label="item.key"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <el-table
                :data="tableData"
                style="width: 100%">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="table-expand">
                        <el-form-item label="id：">
                            <span>{{ props.row.id }}</span>
                        </el-form-item>
                        <el-form-item label="name：">
                            <span>{{ props.row.name }}</span>
                        </el-form-item>
                        <el-form-item label="code：">
                            <span>{{ props.row.code }}</span>
                        </el-form-item>
                        <el-form-item label="租户ID：">
                            <span>{{ props.row.tenantId }}</span>
                        </el-form-item>
                        <el-form-item label="描述：">
                            <span>{{ props.row.description }}</span>
                        </el-form-item>
                        <el-form-item label="创建时间：">
                            <span>{{ props.row.createdOn }}</span>
                        </el-form-item>
                        <el-form-item label="修改时间：">
                            <span>{{ props.row.modifiedOn }}</span>
                        </el-form-item>
                        <el-form-item label="配置：">
                            <span>{{ props.row.config }}</span>
                        </el-form-item>
                        <el-form-item label="资源信息：">
                            <div v-if="props.row.resourceInfo.length > 20">
                                <el-popover
                                        placement="top-start"
                                        width="400"
                                        trigger="hover"
                                        :content="props.row.resourceInfo">
                                    <span slot="reference">{{props.row.resourceInfo.substring(0, 20) + '...'}}</span>
                                </el-popover>
                            </div>
                            <div v-else>
                                <span>{{props.row.resourceInfo}}</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="资源类型：">
                            <span>{{ props.row.resourceType }}</span>
                        </el-form-item>
                        <el-form-item label="状态：">
                            <span>{{ props.row.status }}</span>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column
                    label="ID"
                    prop="id">
            </el-table-column>
            <el-table-column
                    label="name"
                    prop="name">
            </el-table-column>
            <el-table-column
                    label="租户id"
                    prop="tenantId">
            </el-table-column>
            <el-table-column
                    label="code"
                    prop="code">
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" @click="tableEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="tableDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                :total="total"
                :current-page="pageNumber"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
        ></el-pagination>

        <el-dialog :title="dynamicResourceFrom.addOrUpdate === '' ? '新增动态资源' : '编辑动态资源'"
                   width="62%" :visible.sync="dialogEditDynamicResourceVisible" center
                   :close-on-click-modal="false"
                   @closed="dialogEditDynamicResourceClosedFn">
            <el-form label-position="right" label-width="100px" :rules="rules" :model="dynamicResourceFrom"
                     ref="dynamicResourceFrom">
                <el-form-item label="id：">
                    <el-input v-model="dynamicResourceFrom.id" placeholder="请输入id"
                              :disabled="dynamicResourceFrom.addOrUpdate !== ''"></el-input>
                </el-form-item>
                <el-form-item label="名称：" prop="name">
                    <el-input v-model="dynamicResourceFrom.name" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="code：" prop="code">
                    <el-input v-model="dynamicResourceFrom.code" placeholder="请输入code"></el-input>
                </el-form-item>
                <el-form-item label="租户id：" prop="tenantId">
                    <el-input v-model="dynamicResourceFrom.tenantId" placeholder="请输入租户id"></el-input>
                </el-form-item>
                <el-form-item label="描述：" prop="description">
                    <el-input type="textarea" autosize v-model="dynamicResourceFrom.description" placeholder="请输入描述"></el-input>
                </el-form-item>
                <el-form-item label="配置：" prop="config">
                    <el-input type="textarea" autosize v-model="dynamicResourceFrom.config" placeholder="请输入json配置"></el-input>
                </el-form-item>
                <el-form-item label="资源信息：" prop="resourceInfo">
                    <el-input type="textarea" autosize v-model="dynamicResourceFrom.resourceInfo"
                              placeholder="请输入json资源信息"></el-input>
                </el-form-item>
                <el-form-item label="资源类型：" prop="resourceType">
                    <el-select v-model="dynamicResourceFrom.resourceType" filterable allow-create default-first-option clearable placeholder="请选择资源类型">
                        <el-option v-for="item in resourceTypeOptions" :key="item.value" :label="item.key"
                                   :disabled="item.disabled"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态：" prop="status">
                    <el-radio-group v-model="dynamicResourceFrom.status">
                        <el-radio label="ACTIVE"></el-radio>
                        <el-radio label="INACTIVE"></el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEditDynamicResourceVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmButton('dynamicResourceFrom')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data: () => {
            let checkJson = (rule, value, callback) => {
                try {
                    if (typeof JSON.parse(value) == "object") {
                        callback();
                    }
                } catch (e) {
                }
                callback(new Error("请输入正确的json格式"));
            };
            return {
                tableData: [],
                pageSizes: [10, 20, 50, 100],
                pageSize: 10,
                pageNumber: 1,
                total: 0,
                tnId: '', // 租户id
                resourceType: '', // 默认查找all
                status: '', // 默认查找all Todo 目前因为调用接口拼接query的原因，所以当resourceType为''的时候，status字段没有进行使用
                env: '',
                resourceTypeOptions: [],
                statusOptions: [],
                envOptions: [],
                dialogEditDynamicResourceVisible: false,
                dynamicResourceFrom: {
                    addOrUpdate: '', // 判断新增还是编辑
                    id: '',
                    name: '',
                    code: '',
                    tenantId: '',
                    description: '',
                    config: '',
                    resourceInfo: '',
                    resourceType: '',
                    status: '',
                },
                rules: {
                    name: [
                        {required: true, message: '请输入名称', trigger: 'blur'}
                    ],
                    code: [
                        {required: true, message: '请输入code', trigger: 'blur'}
                    ],
                    tenantId: [
                        {required: true, message: '请输入租户id', trigger: 'blur'}
                    ],
                    description: [
                        {required: true, message: '请输入描述', trigger: 'blur'}
                    ],
                    config: [
                        {required: true, message: '请输入配置', trigger: 'blur'},
                        {validator: checkJson, trigger: 'blur'}
                    ],
                    resourceInfo: [
                        {required: true, message: '请输入资源信息', trigger: 'blur'},
                        {validator: checkJson, trigger: 'blur'}
                    ],
                    resourceType: [
                        {required: true, message: '请选择资源类型', trigger: 'blur'}
                    ],
                    status: [
                        {required: true, message: '请选择状态', trigger: 'blur'}
                    ]
                }
            }
        },
        mounted: function () {
            this.getEnvOptions();
            this.getResourceTypeOptions();
            this.getStatusOptions();
            if (this.env !== '') {
                this.getTableData();
            }
        },
        watch: {
            tnId() {
                this.getTableData();
            },
            resourceType() {
                this.pageNum = 1;
                this.getTableData();
            },
            status() {
                this.getTableData();
            },
            env() {
                this.getTableData();
            }
        },
        methods: {
            getTableData: function () {
                const self = this;
                let params = {};
                params.pageNum = self.pageNumber - 1;
                params.pageSize = self.pageSize;
                params.tenantId = self.tnId;
                if (self.resourceType !== '') {
                    params.resourceType = self.resourceType;
                    if (self.status !== '') {
                        params.status = self.status;
                    }
                }
                params.env = self.env;
                self.$axios_api.getDynamicResourceList(params).then(res => {
                    // 更新表格
                    self.tableData = res.rows;
                    // 为了表格判断resourceInfo的长度，故循环将其转换为string
                    for (let item in self.tableData) {
                        self.tableData[item].resourceInfo = JSON.stringify(self.tableData[item].resourceInfo, null, 4);
                    }
                    //更新分页总条数
                    self.total = res.total;
                });
            },
            //分页页码变化
            handleCurrentChange: function (pageNum) {
                this.pageNumber = pageNum;
                this.getTableData();
            },
            handleSizeChange: function (pageSize) {
                this.pageSize = pageSize;
                this.getTableData();
            },
            getResourceTypeOptions: function () {
                this.resourceTypeOptions = [
                    {
                        key: 'all',
                        value: '',
                        disabled: true
                    },
                    {
                        key: 'CONNECTOR',
                        value: 'CONNECTOR'
                    },
                    {
                        key: 'REST_CLIENT',
                        value: 'REST_CLIENT'
                    },
                    {
                        key: 'ACTOR',
                        value: 'ACTOR'
                    },
                    {
                        key: 'TASK',
                        value: 'TASK'
                    },
                    {
                        key: 'AGENT',
                        value: 'AGENT'
                    },
                    {
                        key: 'JOB',
                        value: 'JOB'
                    },
                    {
                        key: 'WEBHOOK',
                        value: 'WEBHOOK'
                    },
                    {
                        key: 'TEMPLATE',
                        value: 'TEMPLATE'
                    },
                    {
                        key: 'UNKNOWN',
                        value: 'UNKNOWN'
                    },
                ]
            },
            getStatusOptions: function () {
                this.statusOptions = [
                    {
                        key: 'all',
                        value: ''
                    },
                    {
                        key: 'ACTIVE',
                        value: 'ACTIVE'
                    },
                    {
                        key: 'INACTIVE',
                        value: 'INACTIVE'
                    }
                ]
            },
            getEnvOptions() {
                const self = this;
                let params = {};
                self.$axios_api.getEnvOptions(params).then(res => {
                    self.env = res.env_options[0].value;
                    self.envOptions = res.env_options;
                });
            },
            // 弹窗关闭按钮
            dialogEditDynamicResourceClosedFn: function () {
                this.dynamicResourceFrom.addOrUpdate = '';
                this.dynamicResourceFrom.id = '';
                this.dynamicResourceFrom.name = '';
                this.dynamicResourceFrom.code = '';
                this.dynamicResourceFrom.tenantId = '';
                this.dynamicResourceFrom.description = '';
                this.dynamicResourceFrom.config = '';
                this.dynamicResourceFrom.resourceInfo = '';
                this.dynamicResourceFrom.resourceType = '';
                this.dynamicResourceFrom.status = ''
            },
            confirmButton(dynamicResourceFrom) {
                this.$refs[dynamicResourceFrom].validate((valid) => {
                    if (valid) {
                        this.addOrUpdateDynamicResourceFn();
                    }
                });
            },
            addOrUpdateDynamicResourceFn: function () {
                const self = this;
                let params = {};
                params.env = self.env;
                params.id = self.dynamicResourceFrom.id;
                params.name = self.dynamicResourceFrom.name;
                params.code = self.dynamicResourceFrom.code;
                params.tenantId = self.dynamicResourceFrom.tenantId;
                params.description = self.dynamicResourceFrom.description;
                params.config = JSON.parse(self.dynamicResourceFrom.config);
                params.resourceInfo = JSON.parse(self.dynamicResourceFrom.resourceInfo);
                params.resourceType = self.dynamicResourceFrom.resourceType;
                params.status = self.dynamicResourceFrom.status;
                let data = JSON.stringify(params);
                // addOrUpdate为空新增，不然编辑
                if (self.dynamicResourceFrom.addOrUpdate === '') {
                    self.$axios_api.saveDynamicResource(data).then(res => {
                        self.$message({
                            message: res,
                            type: 'success'
                        });
                        self.dialogEditDynamicResourceVisible = false;
                        self.getTableData();
                    })
                } else {
                    self.$axios_api.updateDynamicResource(data).then(res => {
                        self.$message({
                            message: res,
                            type: 'success'
                        });
                        self.dialogEditDynamicResourceVisible = false;
                        self.getTableData();
                    })
                }
            },

            tableDelete: function (row) {
                const self = this;
                self.$confirm('此操作将删除该条数据，是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        self.deleteDynamicResourceFn(row);
                    })
                    .catch(() => {
                    });
            },

            deleteDynamicResourceFn: function (row) {
                const self = this;
                let params = {};
                params.dlId = row.id;
                params.env = self.env;
                params.tenantId = row.tenantId;
                self.$axios_api.deleteDynamicResource(params).then(res => {
                    self.$message({
                        message: res,
                        type: 'success'
                    });
                    self.getTableData();
                });
            },

            tableEdit: function (row) {
                const self = this;
                this.dynamicResourceFrom.addOrUpdate = row.id;
                this.dynamicResourceFrom.id = row.id;
                this.dynamicResourceFrom.name = row.name;
                this.dynamicResourceFrom.code = row.code;
                this.dynamicResourceFrom.tenantId = row.tenantId;
                this.dynamicResourceFrom.description = row.description;
                this.dynamicResourceFrom.config = JSON.stringify(row.config, null, 4);
                // 由于在表格的时候resourceInfo已经进行过转成字符串，所以此处不需要再次转换
                this.dynamicResourceFrom.resourceInfo = row.resourceInfo;
                this.dynamicResourceFrom.resourceType = row.resourceType;
                this.dynamicResourceFrom.status = row.status;
                self.dialogEditDynamicResourceVisible = true;
            }
        },
    };
</script>

<style>
    .table-expand {
        font-size: 0;
    }

    .table-expand label {
        width: 100px;
        color: #99a9bf;
        float: left;
    }

    .table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 100%;
    }
</style>